import React, { useState } from 'react';
import Bg from '../../../images/shapes/shape_title_under_line.svg'
import shape1 from '../../../images/shapes/shape_space_5.svg'
import shape2 from '../../../images/shapes/shape_angle_3.webp'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faq_section section_decoration bg-light" style={{ paddingBottom: "150px" }}>
            <div className="container">
                <div className="heading_block text-center">
                    <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                        F.A.Q.
                    </div>
                    <h2 className="heading_text mb-0">
                        Informatie <mark>Over ons</mark>
                    </h2>
                </div>

                <div className="faq_accordion accordion" id="faq_accordion">
                    <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="1">
                                Q. Waarom Praeventor?
                            </AccordionHeader>
                            <AccordionBody accordionId="1" className='acc_body'>
                                <div className="text_a">A.</div>
                                <p>
                                    Praeventor is niet zomaar een naam, maar een belofte.
                                    Een belofte dat wij degenen zijn die cybergevaren voor willen zijn.
                                    Net zoals de praeventores die, door hun waakzame ogen en vooruitziende blik,
                                    onmisbaar waren voor de veiligheid van de Romeinse steden,
                                    zo willen wij vandaag de onmisbare verdedigers zijn van uw digitale veiligheid.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="2">
                                Q. Hoe verschilt Praeventor van andere cybersecuritybedrijven?
                            </AccordionHeader>
                            <AccordionBody accordionId="2" className='acc_body'>
                                <div className="text_a">A.</div>
                                <p>
                                    Wij onderscheiden ons door ons te richten op proactieve, preventieve beveiliging,
                                    zodat dreigingen tijdig worden geïdentificeerd en afgeweerd. Door gebruik te maken
                                    van cutting-edge tools zoals OWASP ZAP, Kali Linux, en monitoring via Graylog,
                                    creëren we een omgeving waarin cybersecurity continue verbeterd wordt.
                                    Daarnaast ligt onze focus op groeiende bedrijven die snel willen opschalen
                                    zonder concessies te doen op het gebied van beveiliging.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="3">
                                Q. Welke soorten klanten helpt Praeventor het meest?
                            </AccordionHeader>
                            <AccordionBody accordionId="3" className='acc_body'>
                                <div className="text_a">A.</div>
                                <p>
                                    Onze belangrijkste klanten zijn startups, scale-ups, en kleine
                                    tot middelgrote bedrijven (MKB) die behoefte hebben aan versterkte digitale beveiliging.
                                    Vooral bedrijven zonder uitgebreide IT-afdeling vinden in ons een partner die hen kan
                                    begeleiden en ondersteunen bij het opzetten en onderhouden van hun beveiligingsinfrastructuur.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="4">
                                Q. Waarom is cybersecurity zo belangrijk voor kleinere bedrijven?
                            </AccordionHeader>
                            <AccordionBody accordionId="4" className='acc_body'>
                                <div className="text_a">A.</div>
                                <p>
                                    Ook kleine bedrijven zijn kwetsbaar voor cyberaanvallen. Cybercriminelen richten zich vaak op bedrijven zonder sterke beveiliging omdat ze makkelijk doelwitten zijn. Praeventor helpt uw bedrijf om deze risico’s te verkleinen, uw klantgegevens te beschermen, en ervoor te zorgen dat uw systemen altijd operationeel blijven.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="5">
                                Q. Welke abonnementen en diensten biedt Praeventor aan?
                            </AccordionHeader>
                            <AccordionBody accordionId="5" className='acc_body'>
                                <div className="text_a">A.</div>
                                <p>
                                    Wij bieden verschillende abonnementsopties aan, van basispakket beveiligingsmonitoring tot volledig beheerde security services inclusief advies en regelmatige penetratietesten. U kunt kiezen uit opties zoals maandelijkse monitoring, kwartaalanalyses, en een volledig servicepakket met zowel tests als trainingssessies voor uw team.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem className="accordion-item">
                            <AccordionHeader targetId="6">
                                Q. Wat houdt een penetratietest in en waarom zou ik dit nodig hebben?
                            </AccordionHeader>
                            <AccordionBody accordionId="6" className='acc_body'>
                                <div className="text_a">A.</div>
                                <p>
                                    Een penetratietest is een gecontroleerde aanvalssimulatie om kwetsbaarheden in uw
                                    systemen te identificeren en op te lossen. Door een dergelijke test uit te voeren,
                                    kunt u zien waar potentiële zwakke plekken zitten en voorkomt u dat cybercriminelen
                                    hiervan gebruikmaken. Wij gebruiken tools zoals Metasploit en technieken uit
                                    The Hacker Playbook om realistische dreigingen te simuleren en zwakke punten bloot te leggen.
                                </p>
                            </AccordionBody>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>
            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="Techco Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="Techco Shape Angle" />
            </div>
        </section>
    )
};
export default FaqSection;
